import { BasicButton, BasicInput, ModalComponent } from "Common/Components";
import React from "react";
import { useFormModal } from "../hooks/useFormModal";

interface ModalFormEmployeProps {
  showModal: boolean;
  onHide: () => void;
}

export const ModalForm: React.FC<ModalFormEmployeProps> = ({
  showModal,
  onHide,
}) => {
  const { t, isEdit, formik, resetForm } = useFormModal(onHide);

  return (
    <ModalComponent
      modalTitle={
        isEdit
          ? t("productClassification.formAdminClassification.TitleEdit")
          : t("productClassification.formAdminClassification.TitleCreate")
      }
      show={showModal}
      onHide={() => {
        onHide();
        resetForm();
      }}
      size="xl"
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          formik.handleSubmit();
        }}
      >
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="col-span-12">
            <BasicInput
              label={t(
                "productClassification.formAdminClassification.fieldDescription"
              )}
              placeholder={t(
                "productClassification.formAdminClassification.placeholderDescription"
              )}
              id="description"
              type="text"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isError={
                !!(formik.touched.description && formik.errors.description)
              }
              errorMessage={formik.errors.description || ""}
            ></BasicInput>
          </div>

          <div className="col-span-12">
            <div className="flex justify-end">
              <BasicButton
                disabled={formik.isSubmitting}
                type="submit"
                onClick={() => {}}
              >
                <span className="text-white">
                  {isEdit
                    ? t(
                        "productClassification.formAdminClassification.TitleEdit"
                      )
                    : t(
                        "productClassification.formAdminClassification.TitleCreate"
                      )}
                </span>
              </BasicButton>
            </div>
          </div>
        </div>
      </form>
    </ModalComponent>
  );
};
